module.exports = __webpack_public_path__ + "Step4_Header_new.382d19bf.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/2018/desktop/headers/Step4_Header_new.png
// module id = 4XRw
// module chunks = 0